// extracted by mini-css-extract-plugin
module.exports = {"SKCard":"styles_SKCard__yUzp_","reverse":"styles_reverse__a06wt"};